import {
  addUniqueValueToArray,
  sortArrayWithPositions
} from 'utils/redux'
import { INIT_APP } from 'store/sagas'

export const NAMESPACE = 'KanBo/Board/view/'
export const INIT = NAMESPACE + 'INIT'
export const SET_PERMISSION_LEVEL = NAMESPACE + 'SET_PERMISSION_LEVEL'
export const SET_NAME = NAMESPACE + 'SET_NAME'
export const SET_IS_TEMPLATE = NAMESPACE + 'SET_IS_TEMPLATE'
export const SET_IS_PUBLIC = NAMESPACE + 'SET_IS_PUBLIC'
export const SET_IS_CLOSED = NAMESPACE + 'SET_IS_CLOSED'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const ADD_LIST = NAMESPACE + 'ADD_LIST'
export const REMOVE_LIST = NAMESPACE + 'REMOVE_LIST'
export const SET_LISTS = NAMESPACE + 'SET_LISTS'
export const POSITION_LIST = NAMESPACE + 'POSITION_LIST'
export const POSITION_LISTS = NAMESPACE + 'POSITION_LISTS'
export const SET_LISTS_SCROLL_LEFT = NAMESPACE + 'SET_LISTS_SCROLL_LEFT'

const defaultView = {
  id: 0,
  name: '',
  isTemplate: false,
  isPublic: false,
  isClosed: false,
  lists: [],
  owners: [],
  members: [],
  visitors: [],
  isLoading: false,
  isLoaded: false,
  permissionLevel: 0,
  listsScrollLeft: 0,
}

const initialState = {}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT_APP:
      return {
        ...initialState,
      }
    case INIT:
      return {
        ...state,
        [action.payload.boardId]: {
          ...defaultView,
          id: action.payload.boardId
        }
      }
    case SET_PERMISSION_LEVEL:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          permissionLevel: action.payload.permissionLevel,
        }
      } : state
    case SET_NAME:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          name: action.payload.name,
        }
      } : state
    case SET_IS_TEMPLATE:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          isTemplate: action.payload.isTemplate,
        }
      } : state
    case SET_IS_PUBLIC:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          isPublic: action.payload.isPublic,
        }
      } : state
    case SET_IS_CLOSED:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          isClosed: action.payload.isClosed,
        }
      } : state
    case SET_LOAD_STATUS:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          isLoading: action.payload.isLoading,
          isLoaded: action.payload.isLoaded,
        }
      } : state
    case ADD_LIST:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          lists: addUniqueValueToArray({
            array: state[action.payload.boardId].lists,
            value: action.payload.listId,
            index: action.payload.index
          }),
        }
      } : state
    case REMOVE_LIST:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          lists: state[action.payload.boardId].lists.filter(id => id !== action.payload.listId),
        }
      } : state
    case SET_LISTS:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          lists: action.payload.lists,
        }
      } : state
    case POSITION_LIST: {
      if (!state[action.payload.boardId]) return state

      const { listId, index } = action.payload
      if (state[action.payload.boardId].lists.indexOf(listId) === -1) return state

      return {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          lists: addUniqueValueToArray({
            array: state[action.payload.boardId].lists,
            value: listId,
            index
          })
        }
      }
    }
    case POSITION_LISTS:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          lists: sortArrayWithPositions(state[action.payload.boardId].lists, action.payload.positionsById),
        }
      } : state
    case SET_LISTS_SCROLL_LEFT:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          listsScrollLeft: action.payload.listsScrollLeft,
        }
      } : state
    default: return state
  }
}

export function init ({ boardId }) {
  return {
    type: INIT,
    payload: {
      boardId
    }
  }
}

export function setPermissionLevel ({ boardId, permissionLevel }) {
  return {
    type: SET_PERMISSION_LEVEL,
    payload: {
      boardId,
      permissionLevel,
    }
  }
}

export function setName ({ boardId, name }) {
  return {
    type: SET_NAME,
    payload: {
      boardId,
      name,
    }
  }
}

export function setIsTemplate ({ boardId, isTemplate }) {
  return {
    type: SET_IS_TEMPLATE,
    payload: {
      boardId,
      isTemplate,
    }
  }
}

export function setIsPublic ({ boardId, isPublic }) {
  return {
    type: SET_IS_PUBLIC,
    payload: {
      boardId,
      isPublic,
    }
  }
}

export function setIsClosed ({ boardId, isClosed }) {
  return {
    type: SET_IS_CLOSED,
    payload: {
      boardId,
      isClosed,
    }
  }
}

export function setLoadStatus ({ boardId, isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      boardId,
      isLoading,
      isLoaded,
    }
  }
}

export function addList ({ boardId, listId, index }) {
  return {
    type: ADD_LIST,
    payload: {
      boardId,
      listId,
      index,
    }
  }
}

export function removeList ({ boardId, listId }) {
  return {
    type: REMOVE_LIST,
    payload: {
      boardId,
      listId,
    }
  }
}

export function setLists ({ boardId, lists }) {
  return {
    type: SET_LISTS,
    payload: {
      boardId,
      lists,
    }
  }
}

export function positionList ({ boardId, listId, index }) {
  return {
    type: POSITION_LIST,
    payload: {
      boardId,
      listId,
      index,
    }
  }
}

export function positionLists ({ boardId, positionsById }) {
  return {
    type: POSITION_LISTS,
    payload: {
      boardId,
      positionsById,
    }
  }
}

export function setListsScrollLeft ({ boardId, listsScrollLeft }) {
  return {
    type: SET_LISTS_SCROLL_LEFT,
    payload: {
      boardId,
      listsScrollLeft,
    }
  }
}